import { AppointmentStatusEnums } from "app/services/api/types/calendar/enums/AppointmentStatusEnums";
import { UrgentConcernStatusEnum } from "app/services/api/types/shiftHandover/enums/UrgentConcernStatusEnum";

export const getStatusTextColorClass = (
  status: UrgentConcernStatusEnum | AppointmentStatusEnums,
): string => {
  switch (status) {
    case UrgentConcernStatusEnum.PENDING:
    case UrgentConcernStatusEnum.IN_PROGRESS:
    case AppointmentStatusEnums.SCHEDULED:
      return "text-warning-600";
    case UrgentConcernStatusEnum.RESOLVED:
    case AppointmentStatusEnums.COMPLETED:
      return "text-success-600";
    case UrgentConcernStatusEnum.DISMISSED:
    case AppointmentStatusEnums.CANCELLED:
      return "text-black";
    default:
      return "text-black";
  }
};

export const getStatusBackgroundColorClass = (
  status: UrgentConcernStatusEnum | AppointmentStatusEnums,
): string => {
  switch (status) {
    case UrgentConcernStatusEnum.PENDING:
    case UrgentConcernStatusEnum.IN_PROGRESS:
    case AppointmentStatusEnums.SCHEDULED:
      return "bg-red-50";
    case UrgentConcernStatusEnum.RESOLVED:
    case AppointmentStatusEnums.COMPLETED:
      return "bg-success-50/50";
    case UrgentConcernStatusEnum.DISMISSED:
    case AppointmentStatusEnums.CANCELLED:
      return "bg-gray-200";
    default:
      return "bg-gray-200";
  }
};
